// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"style_modal-content__HUEz5"};